export function projectsSlider() {
    $(".projects-slider .slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        adaptiveHeight: true,
        dots: true,
        appendArrows: ".slider-nav",
        appendDots: ".slider-nav"
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/projectsSlider.js